<template>

<app-content :loading="is.loading">

	<app-content-head :title="title" :back="$route.meta.back" :readonly="$authorised('con/volunteers/access', 'read')">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />
		
		<app-content-head-actions-item v-if="!isNew" :disabled="isNew" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body v-if="is.initialised">
 
		<app-content-summary v-if="!isNew">

			<app-content-summary-item :is-fixed="true" label="Status" :tag="$constants.volunteers.slot.statusName[item.status]" :status="$constants.volunteers.slot.statusTheme[item.status]" :theme="$constants.volunteers.slot.statusTheme[item.status]" />

			<app-content-summary-item :is-fixed="true" label="Reference" :value="item.reference" />

			<app-content-summary-item :is-end="true" :grow="true" label="Role" type="convention/volunteers/role" :item="item.role" />
			
			<app-content-summary-item :is-start="true" :is-metric="true" label="Volunteer" :value="item.count.filled" alt="0" />
			
			<app-content-summary-item :is-metric="true" label="Capacity" :value="item.capacity" :no-plural="true" alt="0" />
			
		</app-content-summary>

		<app-content-box :readonly="$authorised('con/volunteers/access', 'read')">

			<app-input-checklist v-if="!isNew" :collapsed="!isNew" :fullWidth="true" :singular="true" :columns="1" label="Status" v-model="model.status" :validation="$v.model.status" :options="statusOptions" :descriptions="statusDescriptions" />

			<app-input-text label="Custom Name" :toggle="model.rename.enabled" notes="The default name is auto-generated from the start and end time of the slot." v-on:toggle="model.rename.enabled = !model.rename.enabled" v-model="model.rename.text" :validation="$v.model.rename" placeholder="Enter name" />
			
			<app-input-select label="Day" v-model="model.day" :validation="$v.model.day" :options="references.days" placeholder="Select day" />
			
			<app-input-select label="Time" v-model="model.start" :validation="$v.model.start" :options="references.times" placeholder="Select time" />
			
			<app-input-select label="Duration" v-model="model.duration" :validation="$v.model.duration" :options="references.durations" placeholder="Select duration" />
			
			<app-input-text label="Capacity" placeholder="Enter number..." v-model="model.capacity" :validation="$v.model.capacity" :numeric="true" notes="The maximum number of volunteers required for this slot." />
			
		</app-content-box>

		<app-content-box icon="volunteers.assignments" :not-padded="true" title="Volunteers" v-if="!isNew">

			<app-table :empty="!references.assignments.length" emptyMessage="There are no volunteers assigned.">

				<app-table-head :layout="layout">

					<app-table-column />

					<app-table-column text="Reference" />
					
					<app-table-column text="Name" />
					
					<app-table-column text="Volunteered on" />

				</app-table-head>

				<app-table-body>

					<app-table-row v-on:click="onEditClick(assignment.id)" :layout="layout" v-for="assignment in references.assignments" :key="assignment.id">

						<app-table-cell-label :text="$constants.volunteers.assignment.statusName[assignment.status]" :type="$constants.volunteers.assignment.statusTheme[assignment.status]" :subtext="assignment.reference" />
						
						<app-table-cell-text :text="assignment.badge.reference" />
						
						<app-table-cell-text :text="assignment.badge.name" />
						
						<app-table-cell-text :text="assignment.date.created | localDate('MM/DD/YYYY h:mma')" />
						
					</app-table-row>

				</app-table-body>

			</app-table>

		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, minValue } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			readonly: this.$authorised('con/volunteers/access', 'read'),
			layout: '120px 120px 1fr 240px',
			references: {
				assignments: [],
				days: [],
				durations: [],
				times: []
			},
			model: {
				id: false,
				status: 0,
				rename: {
					enabled: false,
					text: ''
				},
				day: 0,
				duration: 25,
				start: 0,
				capacity: 0
			}
		}

	},

	validations: {
		model: {
			day: {
				required,
                minValue: minValue(1)
			},
			duration: {
				required,
                minValue: minValue(1)
			},
			start: {
				required,
                minValue: minValue(1)
			},
			capacity: {
				required,
                minValue: minValue(1)
			}
		}
	},

	computed: {
	
		statusOptions: function() {
			
			var options = {}
			var filled = this.item.count ? this.item.count.filled : 100000

			var full = (this.item.capacity > filled) ? 'open' : 'full'

			options[this.$constants.volunteers.slot.status[full]] = this.$constants.volunteers.slot.statusName[this.$constants.volunteers.slot.status[full]]

			options[this.$constants.volunteers.slot.status.closed] = this.$constants.volunteers.slot.statusName[this.$constants.volunteers.slot.status.closed]

			return options
		
		},

		statusDescriptions: function() {
		
			var descriptions = {}
			var filled = this.item.count ? this.item.count.filled : 100000

			var full = (this.item.capacity > filled) ? 'open' : 'full'

			descriptions[this.$constants.volunteers.slot.status[full]] = this.$constants.volunteers.slot.statusDescription[this.$constants.volunteers.slot.status[full]]

			descriptions[this.$constants.volunteers.slot.status.closed] = this.$constants.volunteers.slot.statusDescription[this.$constants.volunteers.slot.status.closed]

			return descriptions
		
		}

	},

	methods: {

		onEditClick: function(id) {

			this.$router.push({
				name: 'Convention.Volunteers.Assignments.Edit',
				params: {
					id: id
				},
				query: {
					redirect: 'slot',
					slot: this.item.id,
					role: this.item.role.id
				}
			})

		}

	}

}

</script>

<style scoped>

</style>